import i18n from 'helpers/i18n';
import messages from './messages';
import {
  formatCertification,
  getSingleAgeLevelGroup,
  joinWithAnd
} from '../utils';
import { CertificationItem } from 'types/api/CertificationItemProductKey';

interface ChooseChooseLanguageProps {
  selectedCertification: CertificationItem;
}

function ConfirmationModalBody({
  selectedCertification
}: ChooseChooseLanguageProps) {
  const notChosenCertifications =
    selectedCertification.not_chosen_certifications ?? [];
  const pairedTrainerCertifications =
    selectedCertification.paired_renewable_trainer_certifications ?? [];

  return (
    <div>
      <div className="text-lg font-bold mr-4">
        {i18n.ft(messages.certifications)}
      </div>
      <div className="mb-4 text-lg">
        {formatCertification(selectedCertification)}
      </div>
      <div className="text-lg font-bold mr-4">{i18n.ft(messages.language)}</div>
      <div className="text-lg mr-4">{selectedCertification.language}</div>

      {notChosenCertifications.length > 0 && (
        <div className="mt-4 text-left" style={{ color: '#AC213A' }}>
          <div className="font-bold">{i18n.ft(messages.warningTitle)}</div>
          <div className="font-bold">{i18n.ft(messages.notChosenTitle)}</div>
          <div className="mb-2">
            {notChosenCertifications.map((cert, index) => {
              const ageLevelGroup = getSingleAgeLevelGroup(cert.name);
              const version = cert.name.replace(ageLevelGroup, '').trim();

              return (
                <div key={index}>
                  {`${version} `}
                  <span className="font-semibold">{ageLevelGroup}</span>
                  <div>{cert.label}</div>
                  {index < notChosenCertifications.length - 1 && (
                    <div>{'+'}</div>
                  )}
                </div>
              );
            })}
          </div>
          <div>{i18n.ft(messages.notChosenConfirm)}</div>
        </div>
      )}

      {pairedTrainerCertifications.length > 0 && (
        <div className="mt-4 text-left" style={{ color: '#AC213A' }}>
          <div className="font-bold">{i18n.ft(messages.warningTitle)}</div>
          <div>
            {i18n.ft(messages.pairedTrainerWarning, {
              certificationNames: joinWithAnd(pairedTrainerCertifications)
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export default ConfirmationModalBody;
